import type { VerbTypes } from 'modules/core/lib/verbTypes'

import Policy from './Policy'

class SurveysFormPolicy extends Policy<VerbTypes> {
  checkVerb(verb: VerbTypes): boolean {
    switch (verb) {
      case 'editSurveysForm':
        return this.permissions.edit

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
      // TODO: DRY
    }
  }
}

export default SurveysFormPolicy
